"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  root: {
    padding: 0
  },
  horizontal: {
    alignItems: 'start'
  }
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiStepper.js.map